import React, { Component } from 'react'
import {
	Breadcrumb,
	BreadcrumbItem,
	Button,
	Card,
	CardBody,
	CardFooter,
	Col,
	Container,
	Input,
	ListGroup,
	ListGroupItem,
	ListGroupItemHeading,
	ListGroupItemText,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Pagination,
	PaginationItem,
	PaginationLink,
	Row
} from 'reactstrap';
import Radium from 'radium';
import axios from 'axios';

const CUSTOMERS_PER_PAGE = 20;
const styleCol = {borderTop: "1px solid", color: "#5F5F5F"};
const stylePointer = {cursor: "pointer"};

let savedForms = [];

class AdminCustomerFormsRoute extends Component {
	constructor(props) {
		super(props);

		this.state = {
			forms: savedForms,
			pages: (!savedForms) ? 1 : Math.ceil(savedForms.length / CUSTOMERS_PER_PAGE),
			currentPage: 1,
			modalCustomerForm: false,
			modalRemove: false,
			selectedForm: {},
			formLookup: {},
			formCheck: []
		};
	}

	checkboxForm = (e, id) => {
		// e.preventDefault();

		const contains = this.state.formCheck.includes(id);

		this.setState(prevState => ({
			formCheck: (!contains) ? [...prevState.formCheck, id] : prevState.formCheck.filter((formId) => formId !== id),
			formLookup: {
				...prevState.formLookup,
				[id]: !contains
			}
		}), () => {
			console.log(this.state.formCheck)
		});
	};

	checkboxFormList = (e, id) => {
		e.preventDefault();

		if (!Array.isArray(id)) {
			return;
		}

		const contains = this.state.formCheck.some((formId) => id.indexOf(formId) >= 0);

		this.setState(prevState => ({
			formCheck: (!contains) ? [...prevState.formCheck, ...id] : prevState.formCheck.filter((formId) => id.includes(formId))
		}));
	};

	get = () => {
		if (process.env.REACT_APP_FRONT_END === "true") {
			return;
		}

		axios.get('/api/customer-forms/list')
		.then((res) => {
			this.setState({
				forms: res.data.forms
			});
		})
		.catch((err) => {

		});
	};

	isCustomerInPageRange = (customerId) => {
		return (customerId > (this.state.currentPage - 1) * CUSTOMERS_PER_PAGE && customerId <= this.state.currentPage * CUSTOMERS_PER_PAGE);
	};

	isOnPage = (page) => {
		return (this.state.currentPage === page);
	};

	onNextPage = () => {
		if (this.state.currentPage >= this.state.pages) {
			return;
		}

		this.setState({
			currentPage: ++this.state.currentPage
		});
	};

	onGoToPage = (page) => {
		if (page > this.state.pages || page < 1) {
			return;
		}

		this.setState({
			currentPage: page
		});
	};

	onPrevPage = () => {
		if (this.state.currentPage <= 1) {
			return;
		}

		this.setState({
			currentPage: --this.state.currentPage
		});
	};

	removeForms = () => {
		if (process.env.REACT_APP_FRONT_END === "true") {
			return;
		}
		axios.post('/api/customer-forms/delete', {
			formIds: this.state.formCheck
		})
		.then((res) => {
			this.get();
			this.setState({ modalRemove: false });
		})
		.catch((err) => {

		});
	};

	renderFormsLayout = () => {
		if (!this.state.forms) {
			return null;
		}

		const styleFormRow = {
			transition: 'background-color 250ms linear',
			':hover': {
				backgroundColor: 'rgba(0, 0, 0, 0.03)'
			}
		};

		const styleForm = {
			...styleCol,
			...stylePointer,
			transition: 'background-color 250ms linear',
			':hover': {
				backgroundColor: 'rgba(0, 0, 0, 0.03)'
			}
		}

		let rows = this.state.forms.filter((currentValue, index) => {
			return this.isCustomerInPageRange(index + 1);
		}).map((form, index) => {
			return (
				<div key={index} style={styleFormRow}>
					<Row key={index}>
						<Col xs="1" onClick={() => this.selectForm(form, true)} style={styleForm}>
							{form.listId}
						</Col>
						<Col xs="6" onClick={() => this.selectForm(form, true)} style={styleForm}>
							{form.firstName} {form.lastName}
						</Col>
						<Col xs="4" onClick={() => this.selectForm(form, true)} style={styleForm}>
							{form.submitted}
						</Col>
						<Col xs="1" style={styleCol}>
							<Input
								type="checkbox"
								id="checkbox"
								checked={!!this.state.formLookup[form._id]}
								onChange={(e) => this.checkboxForm(e, form._id)}
							/>
						</Col>
					</Row>
				</div>
			);
		});

		rows.push(this.renderRowPadding(rows.length));

		return rows;
	};

	renderPaginationItems = () => {
		let paginationItems = [];

		for (let i = 1; i <= this.state.pages; i++) {
			paginationItems.push(
				<PaginationItem key ={i} active={i === this.state.currentPage}>
					<PaginationLink onClick={() => this.onGoToPage(i)} style={stylePointer}>
						{i + ''}
					</PaginationLink>
				</PaginationItem>
			);
		}
		return paginationItems;
	};

	renderRowPadding = (pageFormsCount) => {
		let rowPadding = [];
		for (let i = 0, j = CUSTOMERS_PER_PAGE - pageFormsCount; i < j; i++) {
			rowPadding.push(
				<Row>
					<Col style={styleCol}>
					&nbsp;
					</Col>
				</Row>
			);
		}
		return rowPadding;
	};

	selectForm = (customerForm, toggleModal) => {
		this.setState({
			selectedForm: customerForm,
			modalCustomerForm: toggleModal
		});
	};

	toggleModalCustomerForm = () => {
		this.setState({ modalCustomerForm: !this.state.modalCustomerForm });
	};

	toggleModalRemove = () => {
		this.setState({ modalRemove: !this.state.modalRemove });
	}

	componentDidMount() {
		if (!this.state.forms.length) {
			this.get();
		}
	}

	componentWillUnmount() {
		savedForms = this.state.forms;
	}

	render() {
		// console.log(this.state);
		return (
			<div>
				<Breadcrumb tag="ol">
					<BreadcrumbItem tag="li">
						<a>Ecofresh Admin CP</a>
					</BreadcrumbItem>
					<BreadcrumbItem active tag="li">Customer Forms</BreadcrumbItem>
				</Breadcrumb>
				<Card className="mb-3">
					<div className="card-header">
						<i className="fa fa-address-card-o"></i>{' '}
						New Customers
					</div>
					<CardBody>
						<Container className="mt-5 mb-5" style={{maxWidth: "750px"}}>
							<Row>
								<Col xs="1" style={styleCol}>
									ID
								</Col>
								<Col xs="6" style={styleCol}>
									Customer
								</Col>
								<Col xs="5" style={styleCol}>
									Submitted at
								</Col>
							</Row>
							{this.renderFormsLayout()}
							<div className="mt-3 mb-3 text-right">
								<Button color="danger" onClick={this.toggleModalRemove}>
									Remove selected forms
								</Button>
							</div>
							<Pagination className="mt-5" style={{justifyContent: "center"}}>
								<PaginationItem disabled={this.isOnPage(1)}>
									<PaginationLink previous onClick={this.onPrevPage} style={stylePointer} />
								</PaginationItem>
								{this.renderPaginationItems()}
								<PaginationItem disabled={this.isOnPage(this.state.pages)}>
									<PaginationLink next onClick={this.onNextPage} style={stylePointer} />
								</PaginationItem>
							</Pagination>
						</Container>
					</CardBody>
					<CardFooter className="small text-muted" />
				</Card>
				<Modal isOpen={this.state.modalCustomerForm} toggle={this.toggleModalCustomerForm} size="lg">
					<ModalHeader toggle={this.toggleModalCustomerForm}>Customer</ModalHeader>
					<ModalBody>
						<ListGroup>
							<ListGroupItem>
								<ListGroupItemHeading>First Name</ListGroupItemHeading>
								<ListGroupItemText>{this.state.selectedForm.firstName}</ListGroupItemText>
							</ListGroupItem>
							<ListGroupItem>
								<ListGroupItemHeading>Last Name</ListGroupItemHeading>
								<ListGroupItemText>{this.state.selectedForm.lastName}</ListGroupItemText>
							</ListGroupItem>
							<ListGroupItem>
								<ListGroupItemHeading>Email</ListGroupItemHeading>
								<ListGroupItemText>{this.state.selectedForm.email}</ListGroupItemText>
							</ListGroupItem>
							<ListGroupItem>
								<ListGroupItemHeading>Phone</ListGroupItemHeading>
								<ListGroupItemText>{this.state.selectedForm.phone}</ListGroupItemText>
							</ListGroupItem>
							<ListGroupItem>
								<ListGroupItemHeading>Address</ListGroupItemHeading>
								<ListGroupItemText>{this.state.selectedForm.address}</ListGroupItemText>
							</ListGroupItem>
							<ListGroupItem>
								<ListGroupItemHeading>City</ListGroupItemHeading>
								<ListGroupItemText>{this.state.selectedForm.city}</ListGroupItemText>
							</ListGroupItem>
							<ListGroupItem>
								<ListGroupItemHeading>State</ListGroupItemHeading>
								<ListGroupItemText>{this.state.selectedForm.state}</ListGroupItemText>
							</ListGroupItem>
							<ListGroupItem>
								<ListGroupItemHeading>Zip Code</ListGroupItemHeading>
								<ListGroupItemText>{this.state.selectedForm.zip}</ListGroupItemText>
							</ListGroupItem>
							<ListGroupItem>
								<ListGroupItemHeading>Message</ListGroupItemHeading>
								<ListGroupItemText>{this.state.selectedForm.message}</ListGroupItemText>
							</ListGroupItem>
						</ListGroup>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.toggleModalCustomerForm}>OK</Button>
					</ModalFooter>
				</Modal>
				<Modal isOpen={this.state.modalRemove} toggle={this.toggleModalRemove}>
					<ModalHeader toggle={this.toggleModalRemove}>Remove Form(s)</ModalHeader>
					<ModalBody>
						Are you sure you want to remove the selected forms?
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.toggleModalRemove}>No</Button>
						<Button color="danger" onClick={this.removeForms}>Yes</Button>
					</ModalFooter>
				</Modal>
			</div>
		);
	}
}

export default Radium(AdminCustomerFormsRoute)


// WEBPACK FOOTER //
// ./src/admin-components/routes/AdminCustomerFormsRoute.js